import { createIcon } from "@chakra-ui/react";

// Source: https://fontawesome.com/icons/fire-flame-curved?s=solid
export default createIcon({
  displayName: "FireFlameCurved",
  viewBox: "0 0 384 512",
  path: (
    <path
      d="M384 319.1C384 425.9 297.9 512 192 512s-192-86.13-192-192c0-58.67 27.82-106.8 54.57-134.1C69.54 169.3 96 179.8 96 201.5v85.5c0 35.17 27.97 64.5 63.16 64.94C194.9 352.5 224 323.6 224 288c0-88-175.1-96.12-52.15-277.2c13.5-19.72 44.15-10.77 44.15 13.03C215.1 127 384 149.7 384 319.1z"
      fill="currentColor"
    />
  ),
});
